import React, { Component, useRef } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../../../assets/img/svg/save.svg';
import Cancel from '../../../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../../../assets/img/svg/delete.svg';
import docIcon from '../../../../../../assets/img/svg/docIcon.svg';
import del from "../../../../../../assets/img/svg/Del.svg"
import deactive from '../../../../../../assets/img/svg/deactive.svg';
import image from '../../../../../../assets/img/svg/Image.svg';
import InnerImageZoom from "react-inner-image-zoom";
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom";
import withRouter from "../../../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../../../../assets/jss/customStyle";
import $ from "jquery"
import axios from "axios";
import API from "../../../../../../_helpers/endpointService";

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

const CheckboxWithBlackCheck = withStyles({
    root: {
        "& .MuiSvgIcon-root": {
            fill: "#FFFFFF",
            width: 20,
            height: 20,
            border: "1px solid #000000",
            "&:hover": {
                backgroundColor: "#FFFFFF"
            }
        },
        "&$checked": {
            "& .MuiIconButton-label": {
                position: "relative",
                zIndex: 0,
                backgroundColor: "#FFFFFF",
            },
            "& .MuiIconButton-label:after": {
                content: '""',
                height: 10,
                width: 10,
                position: "absolute",
                backgroundColor: "#000000",
                zIndex: -1
            }
        }
    },
    checked: {}
})(Checkbox);

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

class EditDRAWSD extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            isError: false,
            Drawing: {},
            DeleteDrawing: {},
            DelIndex: 0,
            filename: "",
            cancel: false,
            awsname: "",
            Error:
            {
                Title: false,
                Drawing: false,
            },
            addData: {
                Id: 0,
                ProjectId: 0,
                Title: "",

            }
        }
    }

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        this.state.addData.Id = parseInt(localStorage.getItem("DrawEditId"))

    };
    resize1 = () => {
        $("#SEC1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dissecdiv1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dissecdiv").removeClass("d-none");
        $("#Dissecdiv").addClass("d-block");
        $("#SDL").addClass("active-color");
        $("#SDT").addClass("fw-bolder");
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("DrawEditId"))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({});
        this.geteditdrawinginfo(this.state.addData.Id)
        this.state.addData.Title = this.props.SDEDIT_Drawing.Title;
        window.location.pathname == '/dismantlingplan/edit' ? this.setState({ isView: false }) : this.setState({ isView: false })
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#SEC1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dissecdiv1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Dissecdiv").addClass("d-none");
        $("#Dissecdiv").removeClass("d-block");
        $("#SDL").removeClass("active-color");
        $("#SDT").removeClass("fw-bolder");
    }
    handleInputChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData[node] = e.target.value;
        this.setState({});
    };
    geteditdrawinginfo = (id) => {
        let apiUrl = API.BLOCK + 'DismantlingPlan/' + id + '/sectionplan'
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SDEDIT_DRAWING", data: response.data });
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Title = response.data?.Title;
                    this.state.Drawing = {
                        FileName: response.data.Drawing.FileName,
                        ObjectKey: response.data.Drawing.ObjectKey,
                        AwsFolderName: response.data.Drawing.AwsFolderName,
                        AwsUniqueFileName: response.data.Drawing.AwsUniqueFileName,
                        FileExtention: response.data.Drawing.FileExtention,
                        FileUrl: response.data.Drawing.FileUrl,
                        FileSize: response.data.Drawing.FileSize,
                    }
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    DeleteItem = () => {
        this.state.DeleteDrawing = this.state.Drawing;
        this.setState({})
        this.state.Drawing = {};
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }
    deletePhoto = (id, filename) => {
        let apiUrl = API.BLOCK + 'DismantlingPlan/SectionPlan/Drawing?id=' + id + '&filename=' + filename;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (response?.status === 200) {
                  
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    EditCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/dismantlingplan/sectiondivision`)
        }
    }
    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/dismantlingplan/sectiondivision")
    };
    OpenPopupview = (url, name) => {
        this.state.FileUrl = url;
        this.state.FileName = name;
        this.setState({})
        window.$("#viewscreen").modal("show");
    }
    UploadFile = (e) => {
        if (this.state.DelIndex == 0) {
            if (this.state.Drawing.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.deletePhoto(this.state.addData.Id, this.state.awsname)
            }
        }
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                fdata: a,
                FileUrl: await this.toBase64(a),
                check: false,
            }

            this.state.Drawing = upload
            this.setState({})
        })
    };
    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    OpenPopup = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        // this.state.Id = id;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }
    EditSave = () => {
        if (this.state.addData.Title.trim() == '') {
            this.state.Error.Title = true;
            this.state.addData.Title = this.state.addData.Title.trim();
            this.setState({})
        }
        else {
            this.state.Error.Title = false;
            this.state.addData.Title = this.state.addData.Title.trim();
            this.setState({})
        }
        if (Object.keys(this.state.Drawing).length == 0) {
            this.state.Error.Drawing = true;
            this.setState({})
        }
        else {
            this.state.Error.Drawing = false;
            this.setState({})
        }
        if (this.state.addData.Title != '' && Object.keys(this.state.Drawing).length != 0) {
            this.props.dispatch({ type: "CANCEL", data: false });

            let formData = new FormData()
            if (this.state.Drawing.AwsUniqueFileName === undefined) {
                formData.append("drawing", this.state.Drawing.fdata)
            }
            this.addDrawing(this.state.addData, this.state.addData.Id, formData)
        }
    }
    addDrawing = (data, id, formData) => {
        let apiUrl = API.BLOCK + 'DismantlingPlan/' + id + '/sectionplan'
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (this.state.Drawing.fdata != undefined) {
                        this.adddraw(formData, response.data)
                    }
                    else {
                        this.props.navigate("/dismantlingplan/sectiondivision")
                    }

                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    adddraw = (data, id) => {
        this.state.addData.Id = parseInt(localStorage.getItem("DrawEditId"))
        let apiUrl = API.BLOCK + 'DismantlingPlan/id/SectionPlan?id=' + this.state.addData.Id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/dismantlingplan/sectiondivision")
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                }
            });
    };
    DeleteId = () => {
        this.state.addData.Id = parseInt(localStorage.getItem("DrawEditId"))
        this.DeleteData(this.state.addData.Id)
    }
    DeleteData = (id) => {
        let ids = "";
        ids = "ids=" + id
        let apiUrl = API.BLOCK + 'DismantlingPlan/ids/SectionPlan?' + ids;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (response?.status === 200) {
                    this.props.navigate("/dismantlingplan/sectiondivision")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    }
    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"SEC" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="SEC" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Edit Drawing</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i></td>
                                <td className="border-right text-center">
                                    <span className={classes.button} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</span>
                                </td>
                                <td className="border-right text-center">
                                    <span className={`${classes.button}`} onClick={this.EditCancel1} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                </td>
                                <td className="border-right text-center">
                                    <span className={`${classes.button}`} data-target="#deletepopup1" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><button className={classes.button} onClick={this.EditCancel1}><i class="fa fa-arrow-left cursorPointer"></i></button></td>
                                    <td width="95%">

                                        <button className={classes.button} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} pl-3`} onClick={this.EditCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        <button className={`${classes.button} pl-3`} data-target="#deletepopup1" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>

                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mx-2 mt-3">Edit Drawing</h6>}
                        <div className={this.state.isMobile ? "row mx-1" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2"}`}>
                                    <label className={this.state.isMobile ? "pt-2 d-flex" : "float-end d-flex"}>Title&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    {this.state.Error.Title ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Title}
                                            onChange={(e) => { this.handleInputChange(e, "Title") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        />
                                        :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Title}
                                            onChange={(e) => { this.handleInputChange(e, "Title") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "pt-2 d-flex" : "float-end d-flex"}>Drawings&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    {this.state.Error.Drawing ? <>
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            onChange={(e) => this.UploadFile(e)}
                                            accept=".png,.jpg"
                                            placeholder="Browse File"
                                            style={{ borderColor: 'red' }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment style={{ marginRight: 0 }}>
                                                        <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                            <AttachFileIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        <input
                                            type="file"
                                            hidden
                                            error
                                            accept=".png,.jpg"
                                            onChange={(e) => this.UploadFile(e)}
                                            ref={this.inputFile}
                                        />
                                    </>
                                        : <>
                                            <TextField
                                                disabled
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                onChange={(e) => this.UploadFile(e)}
                                                accept=".png,.jpg"
                                                placeholder="Browse File"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment style={{ marginRight: 0 }}>
                                                            <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                                <AttachFileIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                }}
                                            />
                                            <input
                                                type="file"
                                                hidden
                                                accept=".png,.jpg"
                                                onChange={(e) => this.UploadFile(e)}
                                                ref={this.inputFile}
                                            />
                                        </>}
                                </div>
                                <div className={`col-12 col-sm-12   col-md-6 col-lg-6 col-xl-6 pt-2 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : ""}`}>
                                    {Object.keys(this.state.Drawing).length == 0 ? <> </> :
                                        <div className="row align-items-center">
                                            <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center" style={{ display: 'flex' }}>

                                                <div className="ml-2">
                                                    <img src={this.state.Drawing.FileUrl} onClick={() => this.OpenPopupview(this.state.Drawing.FileUrl, this.state.Drawing.FileName)} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                </div>
                                                <div className="col-6 col-sm-6 col-xl-4 col-md-4 col-lg-4">
                                                    <div onClick={() => this.OpenPopupview(this.state.Drawing.FileUrl, this.state.Drawing.FileName)} className="px-2 overflow">{this.state.Drawing.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(this.state.Drawing.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                </div>
                                                <div className="" style={{ marginTop: '-16px' }}>
                                                    <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(this.state.Drawing.FileName, this.state.Drawing.AwsUniqueFileName, this.state.Drawing.Id) }} />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            {/* <div className="row mx-1  border-bottom border-left border-right align-items-center">
                                <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-1 mt-2">
                                    <label className={this.state.isMobile ? "" : "float-end"}>Comments :</label>
                                </div>
                                <div className="col-12 col-sm-12 pb-4 col-md-10 col-lg-10 col-xl-11 pt-4" >
                                    <TextField
                                        multiline
                                        rows={8}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Comments}
                                        onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" data-dismiss="modal" onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteId}><span className="" >Delete</span></button>
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal" data-dismiss="modal" onClick={() => window.$("#deletepopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                        <div class="modal-dialog modal-lg " role="document">
                            <div class="modal-content ">
                                <div class="modal-body pt-0 pb-2 pr-3 pl-3 ">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className='cursorPointer float-end ' id="viewscreen" onClick={() => {
                                                window.$('#viewscreen').modal('hide')

                                            }} >
                                                <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                            </div>
                                        </div>
                                         <div className='col-12 text-center'>
                                                <InnerImageZoom
                                                    moveType="drag"
                                                    zoomScale={2}
                                                    hideCloseButton={true}
                                                    src={this.state.FileUrl}
                                                    hasSpacer={true}
                                                    afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                    afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                />
                                            </div>
                                            
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
            </>
        );
    }

}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        SDEDIT_Drawing: state.SectionDivisionReducer.SDEDIT_Drawing || [],
        // projectList: state.projectReducer.projectList || [],
        // projectNames: state.projectReducer.projectNames || [],
    };
}

EditDRAWSD.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditDRAWSD))
);
